"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionType = exports.Env = exports.Blockchain = void 0;
var Blockchain;
(function (Blockchain) {
    Blockchain["ETH"] = "ETH";
    Blockchain["SOLANA"] = "SOLANA";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
var Env;
(function (Env) {
    Env["STAGING"] = "STAGING";
    Env["PRODUCTION"] = "PRODUCTION";
})(Env = exports.Env || (exports.Env = {}));
var ConnectionType;
(function (ConnectionType) {
    ConnectionType["FOLLOW"] = "FOLLOW";
    ConnectionType["LIKE"] = "LIKE";
    ConnectionType["REPORT"] = "REPORT";
    ConnectionType["WATCH"] = "WATCH";
    ConnectionType["VOTE"] = "VOTE";
})(ConnectionType = exports.ConnectionType || (exports.ConnectionType = {}));
//# sourceMappingURL=types.js.map